import { useQuery } from '@tanstack/react-query';

import { GetArticlesRequestTypes } from '../../api/queries';
import { useServicesContext } from '../../contexts/ServicesContext';

export enum GetDraftArticlesCacheKey {
  GetDraftArticles = 'GET_DRAFT_ARTICLES',
}

type useGetDraftArticlesQueryProps = GetArticlesRequestTypes & {
  enabled?: boolean;
};

export const useGetDraftArticlesQuery = ({
  pageNumber = 1,
  pageSize = 10,
  sortBy = 'asc',
  labelIds = '',
  isGlobalGuide = false,
  enabled = false,
}: useGetDraftArticlesQueryProps) => {
  const { getDraftArticles } = useServicesContext();
  return useQuery({
    queryKey: [
      GetDraftArticlesCacheKey.GetDraftArticles,
      pageNumber,
      pageSize,
      sortBy,
      labelIds,
      isGlobalGuide,
    ],
    queryFn: () =>
      getDraftArticles({
        pageNumber,
        pageSize,
        sortBy,
        labelIds,
        isGlobalGuide,
      }),
    enabled,
    placeholderData: (prev) => prev,
  });
};
